import axios from 'axios';
import { ROOT_URL } from "../Actions/types";

const instance = axios.create({ baseURL: ROOT_URL });

instance.interceptors.request.use(
   async (config) => {
     const cognitotoken = localStorage.getItem("cognitotoken");
     if (cognitotoken) {
        config.headers['cognitotoken'] = cognitotoken;
     } else {
        config.headers['authorizationtoken'] = localStorage.getItem("token") || localStorage.getItem("authorizationtoken"); 
     }
     return config;
   },
  (err) => {
    return Promise.reject(err);
  }
);

export default instance;



// WEBPACK FOOTER //
// ./src/Api/BankDataApi.js